import { ListGroupItemHeading } from "reactstrap"

import React from 'react';
import { Container, Row, Col, Alert } from 'reactstrap';

export default function Loading() {
    return <Container>
        <Row>Loading data...</Row>
    </Container>
}